import citylist from '@/assets/js/config/citydata'

const visitorSheetListSearchFields = [
  {
    label: '结算状态',
    prop: 'settleStatus',
    type: 'select',
    originvalue: [],
    value: 0,
    options: [
      {
        label: '有未结算',
        value: 0
      },
      {
        label: '无未结算',
        value: 1
      },
      {
        label: '全部',
        value: null
      }
    ]
  },
  {
    label: '调查员姓名/联系方式',
    prop: 'executorIds',
    type: 'select',
    multiple: true,
    collapseTags: true,
    originvalue: [],
    value: [],
    options: []
  },
  // {
  //   label: '调查员姓名/联系方式',
  //   prop: 'interviewerInfo',
  //   type: 'input',
  //   originvalue: '',
  //   value: ''
  // },
  {
    label: '任务名称',
    prop: 'jobExecutionName',
    type: 'input',
    originvalue: '',
    value: ''
  },
  {
    start: '审核起始时间',
    end: '审核结束时间',
    prop: 'auditTime',
    type: 'date-picker',
    dateType: 'daterange',
    format: 'yyyy-MM-dd',
    originvalue: '',
    value: [],
    hasMaxMinValue: true
  }
]

visitorSheetListSearchFields.forEach(filterItem => {
  if (filterItem.prop == 'auditTime') {
    filterItem.lg = 7
    filterItem.sm = 24
    filterItem.md = 8
  } else {
    filterItem.lg = 5
    filterItem.sm = 24
    filterItem.md = 8
  }
})
export { visitorSheetListSearchFields }
